export const MAIN_LINK = 'https://tolq.com';
export const CLIENTS_SING_IN_LINK = 'https://clients.tolq.com/auth/sign-in';
export const CLIENTS_SING_UP_LINK = 'https://clients.tolq.com/auth/sign-up';
export const TRANSLATORS_SING_UP_LINK = 'https://translators.tolq.com/sign_up';
export const CLIENTS_LINK = 'https://clients.tolq.com';
export const TRANSLATORS_LINK = 'https://translators.tolq.com';
export const TRANSLATORS_SIGN_IN_LINK = 'https://translators.tolq.com/sign_in';
export const TRANSLATORS_SIGN_UP_LINK = 'https://translators.tolq.com/sign_up';
export const TRANSLATORS_SIGN_UP_FACEBOOK_LINK = 'https://translators.tolq.com/auth/facebook';
export const TRANSLATORS_SIGN_UP_GOOGLE_LINK = 'https://translators.tolq.com/auth/google_oauth2';
export const TRANSLATORS_SIGN_UP_LINKEDIN_LINK = 'https://translators.tolq.com/auth/linkedin';
export const SUPPORT_LINK =
  'mailto:support@tolq.com&subject=Hello Tolq!&body=Can you help with a localization project?';
